module.exports = __webpack_public_path__ + "img/laboratory_02.2374ca93.png";